// helper
import { styleGenerator } from '../../helper';

// constants
import { G_TYPO, G_MARGIN, ICON_HEIGHT, ICON_WIDTH, C_BORDER, C_BRADIUS } from './constants';

/**
 * Internal dependencies
 */
const {
    // generateAlignmentStyles,
    // generateBorderStyles,
    generateResBoxStyles,
    generateRangeStyles,
    generateTypographyStyles,
    // generateResBtnsGroupStyle,
    GlobalStyleHandler,
    generateBorderStyles
} = window.faqmateModules;

// Generate Dynamic Style
const DynamicStyle = props => {
    const { attributes, setAttributes } = props;
    const { uniqueId, textColor, iconColor } = attributes;
    const {
        desktopStyles: gDeskTypo,
        tabletStyles: gTabTypo,
        mobileStyles: gMobTypo
    } = generateTypographyStyles({
        controlName: G_TYPO,
        attributes
    });
    const {
        boxDeskStyles: gDeskMargin,
        boxTabStyles: gTabMargin,
        boxMobStyles: gMobMargin
    } = generateResBoxStyles({
        controlName: G_MARGIN,
        attributes,
        propertyName: 'margin',
        forRadius: false
    });
    const {
        deskStyle: iconHeightDesk,
        tabStyle: iconHeightTab,
        mobStyle: iconHeightMob
    } = generateRangeStyles({
        controlName: ICON_HEIGHT,
        attributes,
        propertyName: 'height'
    });
    const {
        deskStyle: iconWidthDesk,
        tabStyle: iconWidthTab,
        mobStyle: iconWidthMob
    } = generateRangeStyles({
        controlName: ICON_WIDTH,
        attributes,
        propertyName: 'width'
    });
    const {
        desktopStyles: badgeDeskBorder,
        tabletStyles: badgeTabBorder,
        mobileStyles: badgeMobBorder
    } = generateBorderStyles({
        controlName: C_BORDER,
        attributes
    });

    const {
        boxDeskStyles: badgeDeskRadius,
        boxTabStyles: badgeTabRadius,
        boxMobStyles: badgeMobRadius
    } = generateResBoxStyles({
        controlName: C_BRADIUS,
        attributes,
        propertyName: 'border-radius',
        forRadius: true
    });

    // Desktop Styles
    const deskStyles = `
         ${styleGenerator(`.${uniqueId}.wp-block-faqmate-accordions`, [
             {
                 v: gDeskMargin
             }
         ])}
          ${styleGenerator(`.${uniqueId}.wp-block-faqmate-accordions .faq-accordion-button`, [
              {
                  v: gDeskTypo
              },
              {
                  p: 'color',
                  v: textColor
              }
          ])}
          ${styleGenerator(`.${uniqueId}.wp-block-faqmate-accordions .faq-accordion-icon svg`, [
              {
                  v: iconHeightDesk
              },
              {
                  v: iconWidthDesk
              },
              {
                  p: 'color',
                  v: iconColor
              }
          ])}
           ${styleGenerator(`.${uniqueId}.wp-block-faqmate-accordions .faq-accordion-icon svg path`, [
               {
                   p: 'fill',
                   v: iconColor
               }
           ])}
           ${styleGenerator(`.${uniqueId}.wp-block-faqmate-accordions .faq-accordion-item`, [
               {
                   v: badgeDeskBorder
               },
               {
                   v: badgeDeskRadius
               }
           ])}
          
           
    `;
    const tabStyles = `
         
    `;
    const mobStyles = `
         
    `;

    return (
        <GlobalStyleHandler
            attributes={attributes}
            setAttributes={setAttributes}
            deskStyles={deskStyles}
            tabStyles={tabStyles}
            mobStyles={mobStyles}
        />
    );
};

export default DynamicStyle;
